
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locations/[slug]",
      function () {
        return require("private-next-pages/locations/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locations/[slug]"])
      });
    }
  